import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { QuestionResponseEventUpdateInput } from '../generated/globalTypes';
import { updateQuestionResponseEventMutation, updateQuestionResponseEventMutationVariables } from '../generated/updateQuestionResponseEventMutation';
import { questionResponseEventFieldsFragment } from '../models/QuestionResponseEvent';

/**
 * Get a callback to update a QuestionResponseEvent in the store.
 */
export function useUpdateQuestionResponseEventCallback(): [(id: string, model: QuestionResponseEventUpdateInput) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<updateQuestionResponseEventMutation, updateQuestionResponseEventMutationVariables>(
        gql`
            mutation updateQuestionResponseEventMutation ($model: QuestionResponseEventUpdateInput!) {
                updateQuestionResponseEvent(model: $model) {
                    ...questionResponseEventFields
                }
            }

            ${questionResponseEventFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (id: string, model: QuestionResponseEventUpdateInput) => {
        const result = await mutationAction({ variables: { model: { ...model, id: id } } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
